export const BRANDING = {
  APPLICATION: {
    TITLE: "MktgFlo",
  },
  PARTNER: {
    TITLE: "DCM",
  },
};
export const PAGES = {
  ROOT: {
    TITLE: BRANDING.APPLICATION.TITLE,
    URL: "/",
  },
  CAMPAIGN_BRIEFS: {
    TITLE: "Campaign Briefs",
    URL: "/campaign-briefs",
  },
  CAMPAIGN_BRIEF: {
    TITLE: "Campaign Brief",
    URL: "/campaign-brief",
  },
  EXECUTION_BRIEF: {
    TITLE: "Multi Channel Brief",
    URL: "/multi-channel-brief",
  },
  EXECUTION_BRIEFS_LIST: {
    TITLE: "Multi Channel Briefs",
    URL: "/multi-channel-briefs",
  },
  WORK_ORDERS_LIST: {
    TITLE: "Brief Work Orders",
    URL: "/work-orders",
  },
  WORK_ORDER: {
    TITLE: "Brief Work Order",
    URL: "/work-order",
  },
  FLYERS: {
    TITLE: "Design Layouts",
    URL: "/design-layouts",
  },
  FLYER_PAGES: {
    TITLE: "",
    URL: "/flyer/{flyerId}/page",
  },
  FLYER_PAGES_ADD: {
    TITLE: "Add Page",
    URL: "/design-layouts/{flyerId}/add-page",
  },
  DAM: {
    TITLE: "Digital Asset Manager",
    URL: "#",
  },
  SUPPORT: {
    TITLE: "Support",
    URL: "/support",
  },
  LOGIN: {
    TITLE: "Login",
    URL: "/login",
  },
};
